import * as yup from 'yup'
import { pt } from 'yup-locale-pt'

yup.setLocale(pt)

export const validationSchema = yup.object().shape({
  current_password: yup.string().nullable().required().label('Senha atual'),
  password: yup
    .string()
    .nullable()
    .min(8, 'Digite no mínimo 8 caracteres')
    .max(128, 'Digite no máximo 128 caracteres')
    .matches(/^\S*$/, 'Senha não pdoeconter espaços')
    .required()
    .label('Nova senha'),
  password_confirmation: yup
    .string()
    .nullable()
    .oneOf([yup.ref('password'), null], 'Senhas devem estar iguais')
    .required()
    .label('Confirmação de senha')
})
